module.exports = __webpack_public_path__ + "img/almaty1.046ca1ea.jpg";